var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-icon',{attrs:{"name":"user-o","color":"#1989fa","size":"25px"},on:{"click":_vm.goMine}})}
var staticRenderFns = []

export { render, staticRenderFns }